/** AsyncProcessingNotice — "this may take a while" banner shown while an async message is processing. */

import React from "react";
import { useTranslation } from "react-i18next";
import { TriangleAlert } from "lucide-react";

const AsyncProcessingNotice = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-start gap-2.5 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 mb-2 text-amber-800">
      <TriangleAlert size={18} className="shrink-0 mt-0.5 text-amber-500" />
      <div className="text-sm">
        <p className="font-semibold">{t("asyncProcessingTitle")}</p>
        <p className="text-amber-700">{t("asyncProcessingBody")}</p>
      </div>
    </div>
  );
};

export { AsyncProcessingNotice };
export default AsyncProcessingNotice;
